import styles from "./Start.module.css";
import fachoberschule from "./assets/fachoberschule.PNG";

const Start = () => {
    return (
    <>
              <div
                  className={styles.hero}
                  style={{ backgroundImage: `url(${fachoberschule})` }}
              >

              </div>

        <main className="wrapper">
             <section className="wrapperContent">
                <div className={styles.text}>
                    <h1>DIE FACHOBERSCHULE (FOS) </h1>
                    <h3>Schwerpunkt Wirtschaft und Verwaltung</h3>
                    <p>Die Fachoberschule ist ein studienqualifizierender Bildungsgang mit dem Ziel des Erwerbs der
                        Fachhochschulreife (Fachabitur). Diese ist bundesweit anerkannt. Mit dem Abschluss der
                        Fachhochschulreife haben die Absolventinnen und Absolventen die Möglichkeit, bundesweit an einer
                        Hochschule für angewandte Wissenschaften (Fachhochschule) und zudem in Hessen einen gestuften
                        Studiengang an einer Universität zu studieren.</p>
                    <p>Das besondere Merkmal der Fachoberschule ist die Verzahnung einer praktischen Ausbildung in Form
                        eines gelenkten Praktikums oder einer Berufsausbildung mit einer theoretisch orientierten
                        Bildung.</p>
                    <p>Die Fachoberschule baut auf den Kenntnissen des mittleren Abschlusses (Realschulabschluss) auf und
                        führt in verschiedenen Fachrichtungen, Schwerpunkten und Organisationsformen in Verbindung mit einer
                        beruflichen Qualifizierung zur Fachhochschulreife (Fachabitur). Die Fachoberschule wird in zwei
                        Organisationsformen angeboten.</p>
                </div>
            </section>
        </main>
        </>
    )
}
export default Start;